export default __webpack_public_path__ + "static/media/double_fold.1bdbfbeb.jpg";